import React, { useState, useImperativeHandle, forwardRef, useMemo } from "react";
import { Accordion } from "react-bootstrap";
import "./FolderStructure.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase, faTable, faEye, faServer, faCodeBranch, faPlay } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";

const FolderStructure = forwardRef(({ data, type, setFileContent, fileContent, githubLink }, ref) => {
  const [openKeys, setOpenKeys] = useState(new Set());
  const [checkedItems, setCheckedItems] = useState({});
  const dispatch = useDispatch();


  useImperativeHandle(ref, () => ({
    getSelectedData: () => {
      const selectedStructure = { database: {} };
      Object.entries(data.database).forEach(([key, value]) => {
        const checkKeyValue = data.database[key]?.names?.filter(name => checkedItems[`${key}-${name}`]);
        if (key !== "total_objects_count" && checkedItems[key]) {
          selectedStructure.database[key] = {
            count: value.names.filter(name => checkedItems[`${key}-${name}`]).length,
            names: value.names.filter(name => checkedItems[`${key}-${name}`])
          };
        } else if(checkKeyValue?.length > 0){
          selectedStructure.database[key] = {
            count: checkKeyValue?.length,
            names: checkKeyValue
          };
        }
      });
      return selectedStructure;
    },
    checkAll: () => {
      const allChecked = {};
      Object.entries(data.database).forEach(([key, value]) => {
        if (key !== "total_objects_count") {
          allChecked[key] = true;
          value.names.forEach(name => {
            allChecked[`${key}-${name}`] = true;
          });
        }
      });
      setCheckedItems(allChecked);
    },
    uncheckAll: () => {
      setCheckedItems({});
    },
    updateCheckedItems: (updatedData) => {
      const newCheckedItems = {};
      Object.entries(updatedData.database).forEach(([key, value]) => {
        if (key !== "total_objects_count") {
          newCheckedItems[key] = key === value && false;
          value.names.forEach(name => {
            newCheckedItems[`${key}-${name}`] = name ? false : newCheckedItems[`${key}-${name}`];
          });
        }
      });
      setCheckedItems({...checkedItems, ...newCheckedItems});
    }
  }));

  const toggleAccordion = (key) => {
    setOpenKeys(prevKeys => {
      const newKeys = new Set(prevKeys);
      if (newKeys.has(key)) {
        newKeys.delete(key);
      } else {
        newKeys.add(key);
      }
      return newKeys;
    });
  };

  const getIcon = (key) => {
    switch (key.toLowerCase()) {
    case "database": return <FontAwesomeIcon icon={faDatabase} />;
    case "tables": return <FontAwesomeIcon icon={faTable} />;
    case "views": return <FontAwesomeIcon icon={faEye} />;
    case "stored_procedures": return <FontAwesomeIcon icon={faServer} />;
    case "functions": return <FontAwesomeIcon icon={faCodeBranch} />;
    case "triggers": return <FontAwesomeIcon icon={faPlay} />;
    default: return null;
    }
  };

  const handleCheckboxChange = (key, type, isChecked, valueKey) => {
    if(type === "key"){
      let items = {};
      let allChecked = true;
      if(!isChecked){
        allChecked = false;
      }
      Object.entries(data.database).forEach(([dbKey]) => {
        if(dbKey !== "total_objects_count" && dbKey !== key && !checkedItems[dbKey]){
          allChecked = false;
        }
      });
      data.database[key].names.forEach(name => 
        items[`${key}-${name}`] = isChecked
      );
      setCheckedItems(prevItems => ({
        ...prevItems,
        database: allChecked ? true :  false,
        [key]: isChecked,
        ...items
      }));
    } else if(type === "value"){
      let allKeyChecked = true;
      if(!isChecked){
        allKeyChecked = false;
      }
      data.database[valueKey].names.forEach(name => {
        if(!checkedItems[`${valueKey}-${name}`] && `${valueKey}-${name}` !== key){
          allKeyChecked = false;
        }
      });
      setCheckedItems(prevItems => ({
        ...prevItems,
        database: false,
        [valueKey]: allKeyChecked ? true : false,
        [key]: isChecked
      }));
    } else if(type === "main"){
      let items = {
        database: isChecked
      };
      Object.entries(data.database).forEach(([key]) => {
        if(key !== "total_objects_count"){
          items[key] = isChecked;
          data.database[key].names.forEach(name => 
            items[`${key}-${name}`] = isChecked
          );
        }
      });
      setCheckedItems(prevItems => ({
        ...prevItems,
        [key]: isChecked,
        ...items
      }));
    }
    //updateSelectedData();
  };

  /* const updateSelectedData = () => {
    if (type === "database") {
      const selectedStructure = { database: {} };
      Object.entries(data.database).forEach(([key, value]) => {
        if (key !== "total_objects_count" && checkedItems[key]) {
          selectedStructure.database[key] = {
            count: value.count,
            names: value.names.filter(name => checkedItems[`${key}-${name}`])
          };
        }
      });
      setSelectedData(selectedStructure);
    }
  }; */

  /* const checkAll = () => {
    const allChecked = {};
    const checkAllRecursive = (obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (key !== "total_objects_count") {
          allChecked[key] = true;
          if (value.names) {
            value.names.forEach(name => {
              allChecked[`${key}-${name}`] = true;
            });
          }
        }
      });
    };
    checkAllRecursive(data.database);
    setCheckedItems(allChecked);
    updateSelectedData();
  }; */

  const fileCheckboxChange = (key, isChecked) => {
    if(isChecked){
      setFileContent([...fileContent, key]);
    }
    else {
      const files = fileContent;
      const updated = files.filter(item => item !== key);
      setFileContent(updated);
    }
  };

  const renderDatabaseStructure = () => (
    <div className="folder-structure">
      <Accordion activeKey={Array.from(openKeys)}>
        <Accordion.Item eventKey="summary">
          <Accordion.Header onClick={() => toggleAccordion("summary")}>
            <div className="key">
              <input
                type="checkbox"
                checked={checkedItems["database"] || false}
                onChange={(e) => handleCheckboxChange("database", "main", e.target.checked)}
                onClick={(e) => e.stopPropagation()}
              />
              <span className="icon">{getIcon("database")}</span> {type}</div>
            <div className="value">{data.database.total_objects_count} Items</div>
          </Accordion.Header>
          <Accordion.Body>
            <Accordion activeKey={Array.from(openKeys)}>
              {Object.entries(data.database).map(([key, value]) => {
                if (key === "total_objects_count") return null;
                return (
                  <Accordion.Item key={key} eventKey={key}>
                    <Accordion.Header onClick={() => toggleAccordion(key)}>
                      <div className="key">
                        <span className="check">
                          <input
                            type="checkbox"
                            checked={checkedItems[key] || false}
                            onChange={(e) => handleCheckboxChange(key, "key", e.target.checked)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </span>
                        <span className="icon">{getIcon(key)}</span> {key.charAt(0).toUpperCase() + key.slice(1)}
                      </div>
                      <div className="value">{value.count} Items</div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        {value.names.map((item, idx) => (
                          <li key={idx}>
                            <span className="check">
                              <input
                                type="checkbox"
                                checked={checkedItems[`${key}-${item}`] || false}
                                onChange={(e) => handleCheckboxChange(`${key}-${item}`, "value", e.target.checked, key)}
                                onClick={(e) => e.stopPropagation()}
                              /></span>
                            {item}</li>
                        ))}
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );

  const renderFileStructure = () => (
    <div className="folder-structure">
      <Accordion activeKey={Array.from(openKeys)}>
        <Accordion.Item eventKey="summary">
          <Accordion.Header onClick={() => toggleAccordion("summary")}>
            File Structure - {githubLink}
          </Accordion.Header>
          <Accordion.Body>
            <Accordion activeKey={Array.from(openKeys)}>
              <ul>
                {data.map((item, i) => (
                  <li key={i}>
                    <input
                      type="checkbox"
                      checked={fileContent?.find(selectedItem => selectedItem.name === item.name) || false}
                      onChange={(e) => fileCheckboxChange(item, e.target.checked)}
                    />
                    {item.name}</li>
                ))}
              </ul>
            </Accordion>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );

  const renderGitHubFileStructure = () => {
  
    const selectedPaths = useMemo(
      () => new Set(fileContent.map((file) => file.name)),
      [fileContent]
    );
  
    const buildNestedStructure = (scripts) => {
      const tree = {};
      scripts.forEach(({ path, name, content }) => {
        const parts = path.split("\\");
        let current = tree;
        parts.forEach((part, index) => {
          if (!current[part]) {
            current[part] =
              index === parts.length - 1 ? { name, content } : {};
          }
          current = current[part];
        });
      });
      return tree;
    };
  
    const handleCheckboxChange = (node, isChecked, isFolder = false) => {
      dispatch(setFileContent((prev) => {
        if (isChecked) {
          const addFilesFromFolder = (node) => {
            const files = [];
            // eslint-disable-next-line no-unused-vars
            Object.entries(node).forEach(([key, value]) => {
              if (value.name) {
                files.push({
                  name: value.name,
                  content: value.content,
                });
              } else {
                files.push(...addFilesFromFolder(value));
              }
            });
            return files;
          };
          if (isFolder) {
            return [...prev, ...addFilesFromFolder(node)];
          } else {
            return [...prev, { name: node.name, content: node.content }];
          }
        } else {
          const removeFilesFromFolder = (node) => {
            const files = [];
            // eslint-disable-next-line no-unused-vars
            Object.entries(node).forEach(([key, value]) => {
              if (value.name) {
                files.push(value.name);
              } else {
                files.push(...removeFilesFromFolder(value));
              }
            });
            return files;
          };
          const filesToRemove = isFolder ? removeFilesFromFolder(node) : [node.name];
          return prev.filter((file) => !filesToRemove.includes(file.name));
        }
      }));
    };
  
    const isFolderChecked = (node) => {
      const collectFilesFromFolder = (node) => {
        const files = [];
        // eslint-disable-next-line no-unused-vars
        Object.entries(node).forEach(([key, value]) => {
          if (value.name) {
            files.push(value.name);
          } else {
            files.push(...collectFilesFromFolder(value));
          }
        });
        return files;
      };
      const files = collectFilesFromFolder(node);
      return files.every((name) => selectedPaths.has(name));
    };
  
    const renderTree = (node, fullPath = "") => {
      return Object.entries(node).map(([key, value]) => {
        const currentPath = fullPath ? `${fullPath}\\${key}` : key;
  
        if (value.name) {
          // File node
          return (
            <li key={currentPath}>
              <input
                type="checkbox"
                checked={selectedPaths.has(value.name)}
                onChange={(e) =>
                  handleCheckboxChange(value, e.target.checked)
                }
              />
              {value.name}
            </li>
          );
        }
  
        // Folder node
        return (
          <li key={currentPath}>
            <input
              type="checkbox"
              checked={isFolderChecked(value)}
              onChange={(e) =>
                handleCheckboxChange(value, e.target.checked, true)
              }
            />
            <span>{key}</span>
            <ul>{renderTree(value, currentPath)}</ul>
          </li>
        );
      });
    };
  
    const treeStructure = useMemo(() => buildNestedStructure(data), [data]);
  
    return (
      <div className="folder-structure">
        File Structure
        <ul>{renderTree(treeStructure)}</ul>
      </div>
    );
  };
  

  const renderContent = () => {
    switch (type) {
    case "database":
      return renderDatabaseStructure();
    case "file":
      return renderFileStructure();
    case "github":
      return renderGitHubFileStructure();
    default:
      return <p>Unsupported type: {type}</p>;
    }
  };

  return (
    <div>
      {renderContent()}
      {/* {type === "database" && (
        <div>
          <button onClick={checkAll}>Add All</button>
          <button onClick={updateSelectedData}>Add Selected</button>
        </div>
      )} */}
    </div>
  );
});

FolderStructure.displayName = "FolderStructure";

export default FolderStructure;